// Load Highcharts
var Highcharts = require('highcharts');
// This is how a module is loaded. Pass in Highcharts as a parameter.
require('highcharts/modules/exporting')(Highcharts);

var structures_chart_data = $('#structures_chart');


// Generate structures chart
var structures_chart = Highcharts.chart('structures_chart', {

    title: {
        text: structures_chart_data.data('title')
    },

    xAxis: {
        categories: structures_chart_data.data('xaxis'),

        title: {
            text: structures_chart_data.data('x_axis_title'),
        },
        labels: {
          rotation: 90,
          step: 1
        }
    },

    yAxis: {
        title: {
            text: structures_chart_data.data('yaxis_title'),
        }
    },

    labels: {
        items: [{
            style: {
                left: '50px',
                top: '18px',
            }
        }]
    },

    series: [{
        type: 'column',
        name: 'Cumulative',
        data: structures_chart_data.data('cumulative'),
        color: structures_chart_data.data('color'),
      },
      {
          type: 'spline',
          name: 'Per year',
          data: structures_chart_data.data('yaxis'),
          marker: {
              lineWidth: 2,
              lineColor: '#434348',
              fillColor: 'white'
          },
          lineWidth: 3,
          color: '#434348',
      },
    ],
    credits: false,
});

var publications_chart_data = $('#publications_chart');
// Generate publications chart
var publications_chart = Highcharts.chart('publications_chart', {

    title: {
        text: publications_chart_data.data('title')
    },

    xAxis: {
        categories: publications_chart_data.data('xaxis'),

        title: {
            text: publications_chart_data.data('x_axis_title'),
        },
        labels: {
          rotation: 90,
          step: 1
        }
    },

    yAxis: {
        title: {
            text: publications_chart_data.data('yaxis_title'),
        }
    },

    labels: {
        items: [{
            style: {
                left: '50px',
                top: '18px',
            }
        }]
    },

    series: [{
        type: 'column',
        name: 'Cumulative',
        data: publications_chart_data.data('cumulative'),
        color: publications_chart_data.data('color'),
      },
      {
          type: 'spline',
          name: 'Per year',
          data: publications_chart_data.data('yaxis'),
          marker: {
              lineWidth: 2,
              lineColor: '#434348',
              fillColor: 'white'
          },
          lineWidth: 3,
          color: '#434348',
      },
    ],
    credits: false,
});
